import { createFeatureSelector, createSelector } from "@ngrx/store";
import { authFeatureKey, AuthState } from "../reducers";

export const selectAuthState = createFeatureSelector<AuthState>(authFeatureKey);

/*
  {selectedTenant: ..., error: "..."}
*/
export const selectCurrentTenant = createSelector(
  selectAuthState,
  (state: any) => state.tenant
)

export const selectSelectedTenant = createSelector(
  selectCurrentTenant,
  (state: any) => state.selectedTenant
)
